'use client';
import Hero from '@/components/Hero';
import ResetPasswordCard from '@/components/ResetPassword/ResetPasswordCard';
import Errors from '@/services/errors';
import { useRouter } from 'next/navigation';
import Button from '@/components/Button';
import { fetchUserProfile, updateProfile } from '@/services/register';
import { useContext, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { BootstrapContext, ConnectedStateContext, ToastContext } from '@/pagesComponents/Layout';

const Profile = () => {
  const bootstrap = useContext(BootstrapContext);
  const router = useRouter();
  router.query = {};
  const [isConnected] = useContext(ConnectedStateContext);
  const [profile, setProfile] = useState({
    Email: '',
    Prenom: '',
    Nom: '',
    Adresse: '',
    Ville: '',
    CodePostal: '',
    PhoneNumber: '',
  });
  const [receivedAnswers, setReceivedAnswers] = useState({
    received: false,
    message: '',
    type: 'primary',
  });
  const updateToast = useContext(ToastContext);
  const fetchUser = async () => {
    try {
      const data = await fetchUserProfile();
      const profile = {
        Email: data.email,
        Prenom: data.prenom,
        Nom: data.nom,
        Adresse: data.adresse,
        Ville: data.ville,
        CodePostal: data.codePostal,
        PhoneNumber: data.phoneNumber,
      };

      router.push(`?email=${encodeURIComponent(data.email)}`);
      // router.push(`?email=${encodeURIComponent('trevor.kitchen+programmeur@bzinc.ca')}`);
      setProfile(profile);
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };
  const handleInputChange = (e) => {
    const input = e.target;
    const value = input.value;
    const name = input.name;
    const newProfile = { ...profile, [name]: value };
    setProfile((oldProfile) => newProfile);
  };
  const handleProfileFormSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    try {
      const response = await updateProfile(data);
      if (response instanceof Error) {
        throw response;
      }
      const toastObject = {
        message: 'Votre profil a été mis à jour.',
        type: 'success',
      };
      updateToast(toastObject);
      setTimeout(() => {
        const toast = document.getElementById('default-toast');
        const toastInstance = bootstrap.Toast.getOrCreateInstance(toast);
        toastInstance.show();
      }, 100);

      setReceivedAnswers({
        received: true,
        message: 'Votre profil a été mis à jour.',
        type: 'success',
      });
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
      setReceivedAnswers({
        received: true,
        message: 'Error on save',
        type: 'danger',
      });
    }
  };
  useEffect(() => {
    if (isConnected) {
      fetchUser();
    }
  }, [isConnected]);
  useEffect(() => {
    if (receivedAnswers.received) {
      setTimeout(() => {
        setReceivedAnswers((prev) => ({
          ...prev,
          received: false,
        }));
      }, 2000);
    }
  }, [receivedAnswers.received]);
  useEffect(() => {
    setTimeout(() => {
      document.getElementById('profileForm__CodePostal').addEventListener('input', (event) => {
        event.target.setCustomValidity('');
        if (event.target.value.length > 6) {
          const codePostalFirst3Chars = event.target.value.substring(0, 3);
          const codePostalLast3Chars = event.target.value.substring(
            event.target.value.length - 3,
            event.target.value.length
          );
          event.target.value = codePostalFirst3Chars + codePostalLast3Chars;
        }
      });
    }, 400);
  }, []);

  return (
    <>
      <div className="mb-2 mt-md-4 card card-1 sales-card">
        <div className="card-body p-0">
          <Hero
            // model={pageModel}
            title={'Votre Profil'}
          />
        </div>
      </div>
      {isConnected && (
        <div className="card mb-2 mb-md-4 card-3-light">
          <div className="card-body">
            <AnimatePresence>
              {receivedAnswers.received ? (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: 1,
                  }}
                  exit={{ opacity: 0 }}
                  className={`alert alert-${receivedAnswers.type}`}
                  role="alert"
                >
                  {receivedAnswers.message}
                </motion.div>
              ) : null}
            </AnimatePresence>
            <form onSubmit={(e) => handleProfileFormSubmit(e)}>
              <input type="hidden" name="Email" value={profile.Email} />
              <div className="d-flex justify-content-center">
                <div className="row w-100 w-md-75 w-lg-50 justify-content-center">
                  <div className="col-12 col-md-6 form-group">
                    <label className="form-label" htmlFor="profileForm__Prenom">
                      Prénom
                    </label>
                    <input
                      type="text"
                      id="profileForm__Prenom"
                      className="form-control"
                      name="Prenom"
                      placeholder=""
                      onChange={(e) => handleInputChange(e)}
                      value={profile.Prenom}
                    />
                  </div>
                  <div className="col-12 col-md-6 form-group">
                    <label className="form-label" htmlFor="profileForm__Nom">
                      Nom
                    </label>
                    <input
                      type="text"
                      id="profileForm__Nom"
                      className="form-control"
                      name="Nom"
                      onChange={(e) => handleInputChange(e)}
                      value={profile.Nom}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <div className="row w-100 w-md-75 w-lg-50 justify-content-center my-3">
                  <div className="col-12 col-md-6 col-lg-4 col-xl-6 form-group">
                    <label className="form-label" htmlFor="profileForm__Adresse">
                      Adresse
                    </label>
                    <input
                      type="text"
                      id="profileForm__Adresse"
                      className="form-control"
                      name="Adresse"
                      onChange={(e) => handleInputChange(e)}
                      value={profile.Adresse}
                      placeholder=""
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 col-xl-6 form-group">
                    <label className="form-label" htmlFor="profileForm__Ville">
                      Ville
                    </label>
                    <input
                      type="text"
                      id="profileForm__Ville"
                      className="form-control"
                      name="Ville"
                      onChange={(e) => handleInputChange(e)}
                      value={profile.Ville}
                      placeholder=""
                    />
                  </div>
                  {profile && (
                    <div className="col-12 col-md-6 col-lg-4 col-xl-6 form-group">
                      <label className="form-label" htmlFor="profileForm__CodePostal">
                        Code Postal
                      </label>
                      <input
                        type="text"
                        id="profileForm__CodePostal"
                        className="form-control"
                        name="CodePostal"
                        onChange={(e) => handleInputChange(e)}
                        value={profile.CodePostal}
                        max={6}
                        placeholder=""
                      />
                      {!profile.CodePostal.match(/^[A-Z]\d[A-Z]\d[A-Z]\d$/) && (
                        <small className={'form-text text-danger'}>utilisez le format (X1X1X1)</small>
                      )}
                    </div>
                  )}
                  <div className="col-12 col-md-6 col-lg-4 col-xl-6 form-group">
                    <label className="form-label" htmlFor="profileForm__Phone">
                      Téléphone Cellulaire
                    </label>
                    <input
                      type="number"
                      id="profileForm__Phone"
                      className="form-control"
                      name="PhoneNumber"
                      onChange={(e) => handleInputChange(e)}
                      value={profile.PhoneNumber}
                      placeholder=""
                    />
                    <small className={'form-text text-primary'}>
                      Nombres seulement (nous pourrions vous envoyer des messages texte)
                    </small>
                  </div>
                </div>
              </div>
              <div className="row mt-2 justify-content-center">
                <div className="col-12 col-md-6 col-lg-4 form-group d-flex justify-content-center">
                  <Button className="btn btn-primary" type="submit">
                    Sauvegarder
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {isConnected && (
        <div className={'card card-3-light mt-3'}>
          <ResetPasswordCard />
        </div>
      )}
    </>
  );
};

export default Profile;
